var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7549 18.1422C28.7549 16.4227 28.0577 14.8663 26.9321 13.7407C25.8053 12.6139 24.2489 11.9167 22.5294 11.9167C20.81 11.9167 19.2536 12.6139 18.1268 13.7407C17.0012 14.8663 16.304 16.4227 16.304 18.1422C16.304 19.8616 17.0012 21.418 18.1268 22.5436C19.2536 23.6704 20.81 24.3677 22.5294 24.3677C24.2489 24.3677 25.8053 23.6704 26.9321 22.5436C28.0577 21.418 28.7549 19.8616 28.7549 18.1422Z",
    fill: "black",
    fillOpacity: 0.21
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0588 30.5931C15.0588 31.8382 17.8603 33.0833 22.5294 33.0833C26.9097 33.0833 30 31.8382 30 30.5931C30 28.1029 27.0691 25.6127 22.5294 25.6127C17.8603 25.6127 15.0588 28.1029 15.0588 30.5931Z",
    fill: "black",
    fillOpacity: 0.21
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.37fefaee29b6e3e30258d09f067d184f.svg";
export { ForwardRef as ReactComponent };